var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWater = function SvgWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m22.994 5.331 8.15 12.1.036.056c3.151 5.274 1.914 11.964-2.897 15.856-4.794 3.88-11.77 3.88-16.566 0C6.906 29.452 5.67 22.762 8.82 17.488c.011-.02.023-.038.036-.057l8.155-12.1c.276-.41.636-.759 1.056-1.022l.001-.001c1.638-1.025 3.841-.592 4.927 1.024Zm-3.6 1.095c-.123.077-.23.18-.31.3l-8.136 12.072C8.469 22.98 9.436 28.283 13.289 31.4c3.879 3.137 9.545 3.137 13.421 0 3.854-3.117 4.82-8.42 2.34-12.602L20.92 6.726c-.315-.467-1.001-.628-1.526-.3Z",
    clipRule: "evenodd"
  })));
};
export default SvgWater;